/**
 * A third-party brand mark (`<img>`) on the round logo plate. Brand assets are authored for a light
 * ground and can't be recoloured, so in dark the ground comes to them: the `logo-plate` utility
 * (app.css) draws a white disc with an inner vignette and scales the logo to 70% of it. In light the
 * plate is transparent and the logo fills the box, exactly as a bare `<img>` did.
 *
 * `className` sizes the plate — the whole mark — and is merged last, so a caller's `size-*` wins.
 * Decorative: the mark always sits beside a text label.
 */
import * as React from 'react';

import { cn } from '@/_shared/lib/utils';

interface PlatedBrandMarkProps {
  src: string;
  className?: string;
}

export function PlatedBrandMark({ src, className }: PlatedBrandMarkProps): React.JSX.Element {
  return (
    <span aria-hidden data-slot="logo-plate" className={cn('logo-plate shrink-0', className)}>
      {/* `object-contain` letterboxes a non-square asset (Braze's wordmark) instead of crushing it. */}
      <img src={src} alt="" aria-hidden className="object-contain" />
    </span>
  );
}
